module.exports = __webpack_public_path__ + "static/media/ic-logout.d05d034f.svg";